import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("dark"); // Default to admin dark theme

  useEffect(() => {
    // Apply theme class to document
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const setAdminTheme = () => setTheme("dark");
  const setPublicTheme = () => setTheme("light");

  return (
    <ThemeContext.Provider
      value={{ theme, setTheme, toggleTheme, setAdminTheme, setPublicTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
